<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully edited an organization!</div>
        </div>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Edit Company</strong>
          </div>
          <b-form @submit.prevent="editOrganization">
          <b-form-group>
            <label for="organization">Organization</label>
            <b-form-input
              type="text"
              v-validate="'required'"
              v-model="name"
              name="organization_name"
              placeholder="Enter the organization name"
              :class="{'has-error': errors.has('organization_name')}"
            >
            </b-form-input>
            <span class="red">{{ errors.first('organization_name') }}</span>
          </b-form-group>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary">Edit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EditOrganization',
  data () {
    return {
      name: '',
      success: false
    }
  },
  methods: {
    /**
     * Submits the form information to the backend API once submit button is pressed. The information is passed through a validator to make sure they meet the required details.
     */
    editOrganization: function () {
      let self = this

      const { name } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/organizations/${this.$route.params.id}`, {
            name
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Gets the existing organization details in order to auto-populate the edit form.
     */
    getOrganizationDetails: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/organizations/${this.$route.params.id}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data

          self.name = data.name
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getOrganizationDetails()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
